const PENDING_INTENT_KEY = 'bmc:pending-intent';

export interface PendingIntent {
  type: 'INQUIRY';
  teacherHandle: string;
  offeringId?: string;
}

export function savePendingIntent(intent: PendingIntent): void {
  try {
    localStorage.setItem(PENDING_INTENT_KEY, JSON.stringify(intent));
  } catch {
    /* ignore storage errors */
  }
}

export function consumePendingIntent(): PendingIntent | null {
  try {
    const raw = localStorage.getItem(PENDING_INTENT_KEY);
    if (!raw) return null;
    localStorage.removeItem(PENDING_INTENT_KEY);
    return JSON.parse(raw) as PendingIntent;
  } catch {
    localStorage.removeItem(PENDING_INTENT_KEY);
    return null;
  }
}
